import React, { Component } from "react";
import Autocomplete from "react-autocomplete";

import "react-datepicker/dist/react-datepicker.css";
import API from "../../apiService.js";
import ALERT from "../component/Alert";
import moment from "moment";

export class Subjektif extends Component {
  constructor(props) {
    super(props);
    this.state = {
      anamnese: props.patient.anamneses[0]
        ? props.patient.anamneses[0].anamnese
        : "",
      eval: props.patient.anamneses[0] ? props.patient.anamneses[0].eval : "0",
      id: props.patient.anamneses[0] ? props.patient.anamneses[0].id : "",
      nursing_anamnese: props.patient.anamneses[0]
        ? props.patient.anamneses[0].nursing_anamnese
        : "-",
      treat: props.patient.anamneses[0]
        ? props.patient.anamneses[0].treat
        : "-",
      visit_id: props.patient.anamneses[0]
        ? props.patient.anamneses[0].visit_id
        : props.patient.id,
      visit_inpatient_detail_id: props.patient.anamneses[0]
        ? props.patient.anamneses[0].visit_inpatient_detail_id
        : "0",
      icpc_individu: [
        {
          visit_id: "",
          explanation: "",
          log: 0,
          category: "individu",
          icd_name: "",
          soap: "S",
          code: "",
          icd10: "",
          diagnoses: null,
        },
      ],
      icpc_keluarga: [
        {
          visit_id: "",
          explanation: "",
          log: 0,
          category: "keluarga",
          icd_name: "",
          soap: "S",
          code: "",
          icd10: "",
          diagnoses: null,
        },
      ],
      icpc_komunitas: [
        {
          visit_id: "",
          explanation: "",
          log: 0,
          category: "komnunitas",
          icd_name: "",
          soap: "S",
          code: "",
          icd10: "",
          diagnoses: null,
        },
      ],

      list_icpc: [],
      saved_icpc: [],
    };

    this.onChangeIcd = this.onChangeIcd.bind(this);
    this.handleAddInput = this.handleAddInput.bind(this);
    this.onSelect = this.onSelect.bind(this);
    this.getItemValue = this.getItemValue.bind(this);
    this.renderItem = this.renderItem.bind(this);
    this.retrieveDataAsynchronouslyIcd =
      this.retrieveDataAsynchronouslyIcd.bind(this);
  }
  componentDidMount() {
    this.getIcpc();
  }
  getIcpc = async () => {
    const res = await API.get(
      "registration/icpc-transaction/read/" + this.state.visit_id
    );
    if (res) {
      if (res.code == 200) {
        let data = [];
        res.data.map((a, e) => {
          this.state[a.category][0].code != ""
            ? (data = this.state[a.category])
            : (data = []);
          if (a.soap == "S") {
            let dt = {
              ...a,
              icd_name: a.icpc ? a.icpc[0].name : "",
              diagnoses: null,
            };
            this.setState({
              [a.category]: [...data, dt],
            });
          }
        });
        console.log(this.state);
      }
    }
  };
  componentDidUpdate(prevProps) {
    // Typical usage (don't forget to compare props):
    if (this.props.patient.anamneses[0] !== prevProps.patient.anamneses[0]) {
      this.setState({
        anamnese: this.props.patient.anamneses[0]
          ? this.props.patient.anamneses[0].anamnese
          : "",
        eval: this.props.patient.anamneses[0]
          ? this.props.patient.anamneses[0].eval
          : "0",
        id: this.props.patient.anamneses[0]
          ? this.props.patient.anamneses[0].id
          : "",
        nursing_anamnese: this.props.patient.anamneses[0]
          ? this.props.patient.anamneses[0].nursing_anamnese
          : "-",
        treat: this.props.patient.anamneses[0]
          ? this.props.patient.anamneses[0].treat
          : "-",
        visit_id: this.props.patient.anamneses[0]
          ? this.props.patient.anamneses[0].visit_id
          : this.props.patient.id,
        visit_inpatient_detail_id: this.props.patient.anamneses[0]
          ? this.props.patient.anamneses[0].visit_inpatient_detail_id
          : "0",
      });
    }
  }

  handleTextChange = (e) => {
    let anamneses = [];
    this.setState(
      {
        [e.target.name]: e.target.value,
      },
      () => {
        anamneses = { data: [this.state], param: "anamneses" };
        // console.log(this.state);
        this.props.parentCallback(anamneses);
      }
    );
  };
  handleSubmit = (e) => {
    if (this.state.id > 0) {
      this.PutData();
    } else {
      this.PostData();
    }
    this.props.nextTab();
  };
  PostData = async () => {
    var param = this.state;
    const res = await API.post("management/anamneses/create", param);
    // console.log(res);
    if (res.code === 200) {
      this.state.icpc_individu.map(async (icpc) => {
        if (icpc.visit_id) {
          const icpcIndividu = await API.post(
            "registration/icpc-transaction/createIcpc",
            icpc
          );
        }
      });
      this.state.icpc_keluarga.map(async (icpc) => {
        if (icpc.visit_id) {
          const icpcKeluarga = await API.post(
            "registration/icpc-transaction/createIcpc",
            icpc
          );
        }
      });
      this.state.icpc_komunitas.map(async (icpc) => {
        if (icpc.visit_id) {
          const icpcKomunitas = await API.post(
            "registration/icpc-transaction/createIcpc",
            icpc
          );
        }
      });

      ALERT("success", "Berhasil Menyimpan Data ");
    } else {
      ALERT("error", "gagal menyimpan data");
    }
    ALERT("success", "Berhasil Menyimpan Data ");
  };

  PutData = async () => {
    var param = this.state;
    const res = await API.put("management/anamneses/update", param);
    if (res.code === 200) {
      this.state.icpc_individu.map(async (icpc) => {
        if (icpc.visit_id) {
          const icpcIndividu = await API.post(
            "registration/icpc-transaction/createIcpc",
            icpc
          );
        }
      });
      this.state.icpc_keluarga.map(async (icpc) => {
        if (icpc.visit_id) {
          const icpcKeluarga = await API.post(
            "registration/icpc-transaction/createIcpc",
            icpc
          );
        }
      });
      this.state.icpc_komunitas.map(async (icpc) => {
        if (icpc.visit_id) {
          const icpcKomunitas = await API.post(
            "registration/icpc-transaction/createIcpc",
            icpc
          );
        }
      });
      ALERT("success", "Berhasil Menyimpan Data ");
    } else {
      ALERT("error", "gagal menyimpan data");
    }
  };
  onReload = () => {
    this.props.history.push("/pelayanan");
  };

  //icpc individu
  retrieveDataAsynchronouslyIcd = async (e) => {
    // console.log(e);

    const res = await API.get("management/icpc2/read?keyword=" + e);
    if (res.code === 200) {
      this.setState({
        list_icpc: res.data.data,
      });
    } else {
      console.error("Cannot load data from remote source");
    }
  };

  onChangeIcd = (evt, icpc, idx) => {
    const newIcd = this.state[icpc].map((icd, sidx) => {
      if (idx !== sidx) return icd;
      return {
        ...icd,
        visit_id: this.props.patient.id,
        icd_name: evt.target.value,
      };
    });

    this.setState({ [icpc]: newIcd });

    /**
     * Handle the remote request with the current text !
     */
    const par = evt.target.value;
    if (this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      if (par.length > 2) {
        this.retrieveDataAsynchronouslyIcd(par);
      }
    }, 500);
  };

  /**
   * Callback triggered when the autocomplete input changes.
   *
   * @param {Object} val Value returned by the getItemValue function.
   * @return {Nothing} No value is returned
   */
  onSelect(val) {
    this.setState({
      value: val,
    });
    const x = val.split("_", 2);
    console.log("Option from 'database' selected : ", x);
  }

  /**
   * Define the markup of every rendered item of the autocomplete.
   *
   * @param {Object} item Single object from the data that can be shown inside the autocomplete
   * @param {Boolean} isHighlighted declares wheter the item has been highlighted or not.
   * @return {Markup} Component
   */
  renderItem(item, isHighlighted) {
    return (
      <div
        key={item.id}
        style={{ background: isHighlighted ? "lightgray" : "white" }}
      >
        {item.code} _ {item.name}]
      </div>
    );
  }

  getItemValue(item) {
    // You can obviously only return the Label or the component you need to show
    // In this case we are going to show the value and the label that shows in the input
    // something like "1 - Microsoft"
    return `${item.code}_${item.name}`;
  }
  handleInputNameChangeIcd = (evt, icpc, idx) => {
    const val = evt.split("_");
    const newIcd = this.state[icpc].map((icd, sidx) => {
      if (idx !== sidx) return icd;
      return {
        ...icd,
        visit_id: this.props.patient.id,
        code: val[0],
        category: icpc,
        icd_name: val[1],
        soap: "S",
      };
    });

    this.setState({ [icpc]: newIcd });
  };
  // handleInputNameChangeIcd = (evt, icpc) => {
  //   const val = evt.split("_");
  //   const newIcd = {
  //     ...this.state[icpc],
  //     visit_id: this.props.patient.id,
  //     code: val[0],
  //     category: icpc,
  //     icd_name: val[1],
  //     soap: "S",
  //   };
  //   this.setState({ [icpc]: newIcd });
  //   console.log(this.state);
  // };

  handleAddInput = (x) => (evt) => {
    this.setState({
      [evt.target.name]: x,
    });
  };
  //end

  render() {
    // console.log(this.props.patient);
    return (
      <>
        <div className="form-group row">
          <label
            htmlFor="example-text-input"
            className="col-md-12 col-form-label col-form-label-sm"
          >
            Anamnese Keperawatan
          </label>
          <div className="col-md-11 ml-3">
            <div className="row">
              <textarea
                className="form-control form-control-sm"
                type="text"
                placeholder="Keluhan Pasien"
                value={this.state.nursing_anamnese}
                disabled
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-11">
            <div className="form-group row">
              <label
                htmlFor="example-text-input"
                className="col-md-2 col-form-label col-form-label-sm"
              >
                Anamnese
              </label>
              <div className="col-md-10">
                <div className="row">
                  <textarea
                    className="form-control form-control-sm"
                    type="text"
                    placeholder="Keluhan Pasien"
                    name="anamnese"
                    onChange={this.handleTextChange}
                    value={this.state.anamnese}
                    rows={5}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-12">
            {this.state.icpc_individu.map((a, i) => (
              <div className="row" key={i}>
                <label className="col-md-2 col-form-label col-form-label-sm">
                  {i == 0 ? "Individu" : ""}
                </label>
                <div className="col-md-10">
                  <div className=" form-group row">
                    <Autocomplete
                      inputProps={{
                        className: "form-control form-control-sm",
                        placeholder: "ketikkan minimal 3 huruf ICPC",
                      }}
                      ref={(input) => {
                        this.individu = input;
                      }}
                      getItemValue={this.getItemValue}
                      items={this.state.list_icpc}
                      renderItem={this.renderItem}
                      value={a.icd_name}
                      onChange={(e) => this.onChangeIcd(e, "icpc_individu", i)}
                      onSelect={(e) =>
                        this.handleInputNameChangeIcd(e, "icpc_individu", i)
                      }
                      menuStyle={{
                        borderRadius: "3px",
                        boxShadow: "0 2px 12px rgba(0, 0, 0, 0.1)",
                        background: "rgba(255, 255, 255, 0.9)",
                        padding: "2px 0",
                        fontSize: "90%",
                        // position: "absolute",
                        overflow: "auto",
                        zIndex: "100",
                        maxHeight: "50%", // TODO: don't cheat, let it flow to the bottom
                      }}
                      wrapperStyle={{
                        maxWidth: "81.66667%",
                        flex: "0 0 81.66667%",
                        overflow: "auto",
                      }}
                    />
                    <div>
                      <button
                        className="btn btn-sm btn-primary"
                        name="icpc_individu"
                        onClick={this.handleAddInput(
                          this.state.icpc_individu.concat([
                            {
                              visit_id: "",
                              explanation: "",
                              log: 0,
                              category: "individu",
                              icd_name: "",
                              soap: "S",
                              code: "",
                              icd10: "",
                            },
                          ])
                        )}
                      >
                        +
                      </button>
                      <button
                        className="btn btn-sm btn-danger"
                        onClick={() =>
                          this.setState({
                            icpc_individu: this.state.icpc_individu.filter(
                              (s, sidx) => i !== sidx
                            ),
                          })
                        }
                      >
                        -
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
            {this.state.icpc_keluarga.map((d, i) => (
              <div className="row mt-2" key={i}>
                <label className="col-md-2 col-form-label col-form-label-sm">
                  {i == 0 ? "Keluarga" : ""}
                </label>
                <div className="col-md-10">
                  <div className="form-group row">
                    <Autocomplete
                      inputProps={{
                        className: "form-control form-control-sm",
                        placeholder: "ketikkan minimal 3 huruf ICPC",
                      }}
                      ref={(input) => {
                        this.individu = input;
                      }}
                      getItemValue={this.getItemValue}
                      items={this.state.list_icpc}
                      renderItem={this.renderItem}
                      value={d.icd_name}
                      onChange={(e) => this.onChangeIcd(e, "icpc_keluarga", i)}
                      onSelect={(e) =>
                        this.handleInputNameChangeIcd(e, "icpc_keluarga", i)
                      }
                      menuStyle={{
                        borderRadius: "3px",
                        boxShadow: "0 2px 12px rgba(0, 0, 0, 0.1)",
                        background: "rgba(255, 255, 255, 0.9)",
                        padding: "2px 0",
                        fontSize: "90%",
                        // position: "absolute",
                        overflow: "auto",
                        zIndex: "100",
                        maxHeight: "50%", // TODO: don't cheat, let it flow to the bottom
                      }}
                      wrapperStyle={{
                        maxWidth: "81.66667%",
                        flex: "0 0 81.66667%",
                        overflow: "auto",
                      }}
                    />
                    <div>
                      <button
                        className="btn btn-sm btn-primary"
                        name="icpc_keluarga"
                        onClick={this.handleAddInput(
                          this.state.icpc_keluarga.concat([
                            {
                              visit_id: "",
                              explanation: "",
                              log: 0,
                              category: "keluarga",
                              icd_name: "",
                              soap: "S",
                              code: "",
                              icd10: "",
                            },
                          ])
                        )}
                      >
                        +
                      </button>
                      <button
                        className="btn btn-sm btn-danger"
                        onClick={() =>
                          this.setState({
                            icpc_keluarga: this.state.icpc_keluarga.filter(
                              (s, sidx) => i !== sidx
                            ),
                          })
                        }
                      >
                        -
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
            {this.state.icpc_komunitas.map((d, i) => (
              <div className="row  mt-2" key={i}>
                <label className="col-md-2 col-form-label col-form-label-sm">
                  {i == 0 ? "Komunitas" : ""}
                </label>
                <div className="col-md-10">
                  <div className="form-group row">
                    <Autocomplete
                      inputProps={{
                        className: "form-control form-control-sm",
                        placeholder: "ketikkan minimal 3 huruf ICPC",
                      }}
                      ref={(input) => {
                        this.individu = input;
                      }}
                      getItemValue={this.getItemValue}
                      items={this.state.list_icpc}
                      renderItem={this.renderItem}
                      value={d.icd_name}
                      onChange={(e) => this.onChangeIcd(e, "icpc_komunitas", i)}
                      onSelect={(e) =>
                        this.handleInputNameChangeIcd(e, "icpc_komunitas", i)
                      }
                      menuStyle={{
                        borderRadius: "3px",
                        boxShadow: "0 2px 12px rgba(0, 0, 0, 0.1)",
                        background: "rgba(255, 255, 255, 0.9)",
                        padding: "2px 0",
                        fontSize: "90%",
                        // position: "absolute",
                        overflow: "auto",
                        zIndex: "100",
                        maxHeight: "50%", // TODO: don't cheat, let it flow to the bottom
                      }}
                      wrapperStyle={{
                        maxWidth: "81.66667%",
                        flex: "0 0 81.66667%",
                        overflow: "auto",
                      }}
                    />
                    <div>
                      <button
                        className="btn btn-sm btn-primary"
                        name="icpc_komunitas"
                        onClick={this.handleAddInput(
                          this.state.icpc_komunitas.concat([
                            {
                              visit_id: "",
                              explanation: "",
                              log: 0,
                              category: "komnunitas",
                              icd_name: "",
                              soap: "S",
                              code: "",
                              icd10: "",
                            },
                          ])
                        )}
                      >
                        +
                      </button>
                      <button
                        className="btn btn-sm btn-danger"
                        onClick={() =>
                          this.setState({
                            icpc_komunitas: this.state.icpc_komunitas.filter(
                              (s, sidx) => i !== sidx
                            ),
                          })
                        }
                      >
                        -
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <button className="btn btn-primary" onClick={this.handleSubmit}>
          Simpan
        </button>
        <button className="btn btn-danger" onClick={this.onReload}>
          Tutup
        </button>
      </>
    );
  }
}

export default Subjektif;
